import api from 'services/api';
import { IDResource } from 'types';
import { Dispatch } from 'redux';
import Logger from 'components/common/helpers/devConsoleLog';
import {
  GET_DRESOURCES,
  CREATE_DRESOURCES,
  DELETE_DRESOURCE,
  EDIT_DRESOURCE,
} from './actionTypes';
import { showSpinner, hideSpinner } from './spinner';

export const createResoureces = (
  data: IDResource,
  unitId: number,
  onError: (msg: string) => void,
  onSuccess?: () => void
) => async (dispatch: Dispatch): Promise<void> => {
  dispatch(showSpinner());

  try {
    const {
      data: resData,
    } = await api.post(`/units/${unitId}/digital-resources`, { data: [data] });

    dispatch({
      type: CREATE_DRESOURCES,
      payload: {
        unitId,
        resources: resData,
      },
    });

    if (onSuccess) {
      onSuccess();
    }
  } catch (err) {
    const { response } = err;

    Logger('createResoureces error:', response);

    if (onError) {
      if (response?.data?.message[0].includes('data.0.'))
        onError(response?.data?.message[0].split('.')[2]);
    }
  } finally {
    dispatch(hideSpinner());
  }
};

export const editResoureces = (
  data: IDResource,
  unitId: number,
  onError: (msg: string) => void,
  onSuccess?: () => void
) => async (dispatch: Dispatch): Promise<void> => {
  dispatch(showSpinner());

  try {
    const { data: updated } = await api.put(
      `/units/${unitId}/digital-resources/${data.id}`,
      data
    );

    dispatch({
      type: EDIT_DRESOURCE,
      payload: {
        unitId,
        updated,
      },
    });

    if (onSuccess) {
      onSuccess();
    }
  } catch (err) {
    const { response } = err;

    Logger('createResoureces error:', response);

    if (onError) {
      onError(response?.data?.message);
    }
  } finally {
    dispatch(hideSpinner());
  }
};

export const getResources = (unitId: number) => async (
  dispatch: Dispatch
): Promise<void> => {
  try {
    const { data } = await api.get(`/units/${unitId}/digital-resources`);

    const formatted = data.map((r: IDResource) => ({
      ...r,
      type: r?.type?.toLocaleLowerCase(),
    }));

    dispatch({
      type: GET_DRESOURCES,
      payload: {
        unitId,
        resources: formatted,
      },
    });
  } catch (error) {
    Logger('getResources error:', error);
  }
};

export const deleteResources = (unitId: number, resourceId: number) => async (
  dispatch: Dispatch
): Promise<void> => {
  try {
    await api.delete(`/units/${unitId}/digital-resources/${resourceId}`);

    dispatch({
      type: DELETE_DRESOURCE,
      payload: {
        unitId,
        resourceId,
      },
    });
  } catch (error) {
    Logger('getResources error:', error);
  }
};
